define('AuctionAutoTranslate', function () {

  function setup() {
    // only for lot page
    // for auction page is in auto_translate_warning_new
    if ($('#lot_list').length < 1) {
      autotranslation_lot_page();
    }
  }
  function ab_machine_translation_default_on(){
    return false;
  }
  // on auction list page
  function autotranslation_auction_page() {
    var $lot_list = $('#lot_list');
    var $all_lots = $lot_list.children('.cw-item-auctionlot');
    var converted_all = false;
    $all_lots.each(function(){
      var converted = false;
      var lot_has_autotranslation = false;
      var $lot = $(this);
      // if data_translated is different from data_original, the lot has no manual translation,
      // and data_translated is the auto-translation of data_original
      var attr_name = 'data_original';
      $lot.find('.auction_auto_translate:visible').each(function(){
        var $_this = $(this);
        if ($_this.attr('data_translated') !== $_this.attr(attr_name)  ) {
          lot_has_autotranslation = true;
          return false;
        }
      });
      if (lot_has_autotranslation) {
        $lot.addClass('lot_has_autotranslation').find('.cw-lot_content').append(
          $('<div/>').addClass('cw-autotranslate_lot')
            .append(
              $('<span/>').addClass('cw-autotranslate_lot__show_translation')
                .append(
                  $('<a/>')
                    .text(TRANSLATIONS.show_translation)
                    .on('click.autotranslate', function(){
                      toggle_autotranslation_per_lot($lot, true, true, true);
                      if (!converted && typeof(AB) != 'undefined' && AB.conversion) {
                        AB.conversion('autotranslation_toggle_auction');
                        converted = true;
                      }
                    })
                )
            )
            .append(
              $('<span/>').addClass('cw-autotranslate_lot__show_original')
                .append($('<span/>').text(TRANSLATIONS.automatically_translated + ' '))
                .append(
                  $('<a/>')
                    .text(TRANSLATIONS['auction_lot_translation_turn_off'])
                    .on('click.autotranslate', function(){
                      if ($lot_list.hasClass('cw-autotranslate_all')) {
                        toggle_autotranslation_per_lot($all_lots, false, true, true);
                        if (!converted_all && typeof(AB) != 'undefined' && AB.conversion) {
                          AB.conversion('autotranslation_toggle_auction_all');
                          converted_all = true;
                        }
                      } else {
                        toggle_autotranslation_per_lot($lot, false, true, true);
                        if (!converted && typeof(AB) != 'undefined' && AB.conversion) {
                          AB.conversion('autotranslation_toggle_auction');
                          converted = true;
                        }
                      }
                    })
                )
                .append($('<span/>').text(' | ').addClass('cw-autotranslate_lot__translate_all'))
                .append(
                  $('<a/>').addClass('cw-autotranslate_lot__translate_all')
                    .text(TRANSLATIONS.translate_entire_auction)
                    .on('click.autotranslate', function(){
                      $lot_list.addClass('cw-autotranslate_all');
                      toggle_autotranslation_per_lot($all_lots, true, true, true);
                      if (!converted_all && typeof(AB) != 'undefined' && AB.conversion) {
                        AB.conversion('autotranslation_toggle_auction_all');
                        converted_all = true;
                      }
                    })
                )
            )
        );
      }
    });
    var $lots_with_autotranslation = $all_lots.filter('.lot_has_autotranslation');
    if ($lots_with_autotranslation.length > 0) {
      AuctionPage.isotope_layout();
    }
  }

  // on lot page
  function autotranslation_lot_page() {
    var converted = false,
        $lot = $('.cw-lot'),
        $translation_switch = $lot.find('.cw-autotranslate_lot');
    if ($translation_switch.length > 0) {
      var $link = $translation_switch.find('a.cw-autotranslate_lot__link');
      $link.on('click', function(evt){
        if ($lot.hasClass('cw-autotranslate_active')) {
          toggle_autotranslation_per_lot($lot, false, false, true);
        } else {
          toggle_autotranslation_per_lot($lot, true, false, true);
        }
        if (!converted && typeof(AB) != 'undefined' && AB.conversion) {
          AB.conversion('autotranslation_toggle_lot');
          converted = true;
        }
      });
    }
  }

  // We use a GTM Tag to forward events to GA
  // https://tagmanager.google.com/#/container/accounts/21729727/containers/776266/workspaces/237/tags
  function gaSendTranslationEvent(action) {
    var dataLayer = window.dataLayer;
    if (typeof(dataLayer) == 'undefined') { return; }

    dataLayer.push({
      'event': 'ga-event',
      'eventCategory': 'Translation',
      'eventAction': action
    });
  }

  function toggle_autotranslation_per_lot($lots, state, layout, userInteraction) {

    var original = 'data_original';

    var content_attribute = state ? 'data_translated': original;
    $lots.find('.auction_auto_translate').each(function() {
      var $el = $(this);
      $el.html($el.attr(content_attribute));
    });

    if (state) {
      $lots.addClass('cw-autotranslate_active');
      if (userInteraction) { gaSendTranslationEvent('enable autotranslation') }
    } else {
      $lots.removeClass('cw-autotranslate_active');
      $('#lot_list').removeClass('cw-autotranslate_all');

      if (userInteraction) { gaSendTranslationEvent('disable autotranslation') }
    }

    if (layout) {
      // autotranslation might impact size, so an Isotope layout action is needed
      // don't do this for each lot on init, but only after all lots are processed
      AuctionPage.isotope_layout();
    }
  }

  return {
    setup:setup,
    autotranslation_auction_page:autotranslation_auction_page,
    ab_machine_translation_default_on:ab_machine_translation_default_on,
  };

});
